/* global define */

require([
	'jquery',
	'views/MasterView'
], function($, MasterView) {

	'use strict';

	// Some Global Helpers
	$.extend($.expr[':'], {
		'containsi': function(elem, i, match/*, array*/) {
			return (elem.textContent || elem.innerText || '').toLowerCase()
				.indexOf((match[3] || '').toLowerCase()) >= 0;
		}
	});

	$.fn.center = function() {
		this.css('position', 'absolute');
		this.css('top', Math.max(0, (($(window).height() - $(this).outerHeight()) / 2) + $(window).scrollTop()) + 'px');
		this.css('left', Math.max(0, (($(window).width() - $(this).outerWidth()) / 2) + $(window).scrollLeft()) + 'px');
		return this;
	};

	if (typeof String.prototype.endsWith !== 'function') {
		String.prototype.endsWith = function(suffix) {
			return this.indexOf(suffix, this.length - suffix.length) !== -1;
		};
	}

	if (typeof Array.prototype.remove !== 'function') {
		Array.prototype.remove = function(from, to) {
			var rest = this.slice((to || from) + 1 || this.length);
			this.length = from < 0 ? this.length + from : from;
			return this.push.apply(this, rest);
		};
	}

	new MasterView().render();

});

define("../js/app", function(){});

